export enum HeaderMode {
  Duplication,
  Edit,
  Idle,
  Selection,
}
